import { baseTheme } from '@streamlain/theme';

export const edgelessCanvasBackgroundVar =
  '--streamlain-edgeless-canvas-background-color';
export const edgelessCanvasGridColorVar =
  '--streamlain-edgeless-canvas-grid-color';
export const minimapPanelBackgroundVar =
  '--streamlain-minimap-panel-background';
export const minimapPanelBorderColorVar =
  '--streamlain-minimap-panel-border-color';
export const minimapPanelBorderRadiusVar =
  '--streamlain-minimap-panel-border-radius';
export const minimapPanelBorderWidthVar =
  '--streamlain-minimap-panel-border-width';
export const minimapPanelShadowVar = '--streamlain-minimap-panel-shadow';
export const minimapControlColorVar = '--streamlain-minimap-control-color';

export const minimapPanelBackground = `var(${minimapPanelBackgroundVar}, var(${edgelessCanvasBackgroundVar}, var(--streamlain-v2-layer-background-secondary, var(--streamlain-background-secondary-color))))`;
export const minimapPanelBorderColor = `var(${minimapPanelBorderColorVar}, color-mix(in srgb, var(--streamlain-v2-button-primary, var(--streamlain-primary-color)) 34%, transparent))`;
export const minimapPanelBorderRadius = `var(${minimapPanelBorderRadiusVar}, 8px)`;
export const minimapPanelBorderWidth = `var(${minimapPanelBorderWidthVar}, 1px)`;
export const minimapPanelBorder = `${minimapPanelBorderWidth} solid ${minimapPanelBorderColor}`;
export const minimapPanelShadow = `var(${minimapPanelShadowVar}, var(--streamlain-shadow-2))`;
export const minimapPanelBoxSizing = 'border-box';

export const minimapDockTop = '12px';
export const minimapDockRight = '12px';
export const minimapDockGap = '8px';
export const minimapDockWidth = '180px';
export const minimapDockWidthMedium = '220px';
export const minimapDockWidthLarge = '260px';
export const minimapCanvasHeight = '120px';
export const minimapCanvasHeightMedium = '140px';
export const minimapCanvasHeightLarge = '160px';

export const minimapControlGap = '4px';
export const minimapControlSize = '32px';
export const minimapControlIconSize = '24px';
export const minimapControlPaddingValue = 4;
export const minimapControlPadding = '4px';
export const minimapControlBoxSizing = 'border-box';
export const minimapControlAppearance = 'none';
export const minimapControlMargin = '0';
export const minimapControlTextAlign = 'center';
export const minimapControlBorder = 'none';
export const minimapControlBorderRadius = '4px';
export const minimapControlBackground = 'transparent';
export const minimapControlColor = `var(${minimapControlColorVar}, var(--streamlain-icon-color))`;
export const minimapControlHoverColor = 'var(--streamlain-primary-color)';
export const minimapControlHoverBackground = 'var(--streamlain-hover-color)';
export const minimapControlFocusOutline = `2px solid ${minimapControlHoverColor}`;
export const minimapControlFontFamily = baseTheme.fontSansFamily;
export const minimapControlFontSize = '12px';
export const minimapControlFontStyle = 'normal';
export const minimapControlFontWeight = '500';
export const minimapControlFontFeatureSettings = 'normal';
export const minimapControlLineHeight = 'normal';
export const minimapZoomPercentWidth = '40px';
